'use client';

import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { SvgLoader } from '@/app/elements/svg/loader';
import { gtmPush } from '@/utils/tracking/gtm';
import type { GtmEvent } from '@/utils/tracking/gtm/types';
import { classes } from '@/utils/classes/classes';
import { getPlatformBridge } from '@/logic/bridges';

import './styles/default.scss';
import { useStore } from '@/store/store';

type SwjRulesInfoButtonProps = {
    extraClassName: string;
    href: string;
    openInBrowser: boolean;
    gtmEvent?: GtmEvent;
    onClickEvent?: () => void;
};

export const SwjRulesInfoButton = ({
    extraClassName,
    href,
    openInBrowser,
    gtmEvent,
    onClickEvent
}: SwjRulesInfoButtonProps) => {
    const router = useRouter();
    const handleShowLoading = useStore((state) => state.loading.handleShowLoading);

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();

        if (onClickEvent) {
            onClickEvent();
        }

        if (gtmEvent) {
            gtmPush(gtmEvent);
        }

        if (openInBrowser) {
            const platformBridge = getPlatformBridge();
            platformBridge.exec('redirectToBrowser', href);
            platformBridge.exec('openExternalWebView', href);
        } else {
            handleShowLoading();
            router.push(href);
        }
    };

    if (openInBrowser) {
        return (
            <a className={classes(extraClassName)} href={href} onClick={handleClick}>
                <SvgLoader className="swj-info-button--enhanced" iconName="info" />
            </a>
        );
    }

    return (
        <Link className={classes(extraClassName)} href={href} onClick={handleClick}>
            <SvgLoader className="swj-info-button--enhanced" iconName="info" />
        </Link>
    );
};
